export const state = () => ({
	hideAds: false,
});

export const mutations = {
	SET_HIDE_ADS(state, hideAds) {
		state.hideAds = typeof hideAds === "boolean" ? hideAds : false;
	},
};
